
import axios from "axios";
import { URL_BASE } from "../config/url-server";

const clientId = localStorage.getItem("client")
const accessToken = localStorage.getItem("token")



export const getList = async (params) => {
   const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
 
  try {
    const response = await axios.get(URL_BASE+"rainfall/list", config);
    const listado = response?.data || null;
    return listado;
  } catch (error) {
    console.error("Error :", error);
    return null;
  }
};




export const insert = async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"rainfall/insert", data, config)
    return response;
  } catch (error) {
    console.error("Error :", error);
    return error.response;
  }
};




export const deleteRecord = async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"rainfall/delete", data, config)
    const responseData = response.data;
    return responseData;
  } catch (error) {
    console.error("Error :", error);
    return null;
  }
};



  export default{
    getList,
    insert,
    deleteRecord
  }

